
<template>
    <div class="cart-items">
        <div class="cart-item" :key="key" v-for="(item, key) in cartItems" tabindex="0">
            <span :title="item.Name" class="cart-item__name">({{ item.Quantity }}) {{ item.Name }}</span>
            <strong class="cart-item__price">{{ formatPrice(item.UnitPrice * item.Quantity ) }}</strong>
        </div>

        <button v-if="hiddenItems > 0" @click="showAllItems" class="cart-items__cta" :aria-label="$ml.get('ariaSeeAllItems')">
            <span v-text="shouldShowAllItems ? $ml.get('hideItems') : $ml.get('seeAllItems')" />
            <img :class="{ active: shouldShowAllItems }" src="@/assets/img/icons/arrow-down-blue.svg" alt="" tabindex="-1" />
        </button>

        <DiscountOverview />
    </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex';
  import moneyHelper from '@/helpers/moneyHelper';
  import DiscountOverview from './OrderOverview/components/DiscountOverview.vue';

  export default {
      components: {
          DiscountOverview
      },

      data() {
          return {
              shouldShowAllItems: false,
              itemsToPreview: this.isDesktop ? 5 : 2
          };
      },
      
      props: {
          isDesktop: {
              type: Boolean,
              default: false
          }
      },

      computed: {
          ...mapGetters({
              formattedPrice: 'payment/getFormattedPrice'                
          }),
          ...mapState('cart', ['Items']),

          cartItems() {
              if (this.shouldShowAllItems)
                  return this.Items;

              return this.Items.slice(0, this.itemsToPreview);
          },

          hiddenItems() {
              let hiddenItems = this.Items.length - this.itemsToPreview;

              return (hiddenItems > 0) ? hiddenItems : 0;
          },
      },

      methods: {
          showAllItems() { 
              this.shouldShowAllItems = !this.shouldShowAllItems;
          },

          formatPrice(unitPrice) {
              let totalPrice = unitPrice / 100; // Transforma centavos em real.

              return `R$ ${moneyHelper.formatToPrice(totalPrice)}`;
          }
      }
  };
</script>

<style lang="scss" scoped>

  .cart-items {

    &__cta {
        //btn reset
        background: none;
        border: none;
        margin: 24px 0 0;
        padding: 0;
        cursor: pointer;

        span {
          font-size: 16px;
          font-weight: 700;
          line-height: 24px;
          color: #0667CD;
        }

        img {
          margin-left: 8px;
          &.active {
              transform: rotate(180deg);
          }
        }
    }

  }
  
  .cart-item {
      display: flex;
      justify-content: space-between;
      
      &:not(:last-of-type) {
        margin-bottom: 24px;
      }

      &__name {
          font-size: 16px;
          line-height: 24px;
          font-weight: 500;
          color: #000;
          flex: 1;
          
          
          @media screen and (min-width: 1025px) {
            line-height: normal;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
      }
        
      &__price {
          font-size: 16px;
          line-height: 24px;
          font-weight: 500;
          color: #000;
          margin-left: 8px;
          
          @media screen and (min-width: 1025px) {
              line-height: normal;
              margin-left: 16px;
              white-space: nowrap;
          }
      }
  }
</style>
